import type { IClientTarget, ISiteTarget } from "wombat-global/src/typings";

import { webLinkPath } from "../router/utilities";

type Target = IClientTarget | ISiteTarget;
type TargetPermissionCheck = (
  target: Target,
  permissionFlag: number,
) => boolean;

export function getHasTodoLandingPath(
  _target: Target,
  _hasPermission: TargetPermissionCheck,
): boolean {
  return false;
}

export function getTargetLandingPath(
  target: Target,
  _hasPermission: TargetPermissionCheck,
): string {
  return webLinkPath(target);
}
